<template>
    <b-row>
        <b-col>
            <datetime v-model="fullDateString"
                      type="date"
                      input-class="form-control"
                      :state="state"
                      value-zone="local"
                      v-if="isIE">
                <b-button slot="after"
                          :disabled="!fullDateString"
                          @click="date = null">X
                </b-button>
            </datetime>
            <b-form-input :state="state"
                          v-model="date"
                          type="date"
                          :disabled="disabled"
                          v-if="!isIE"></b-form-input>
            <!--            <b-form-input :state="state" v-model="date" type="date" :disabled="disabled"></b-form-input>-->
        </b-col>
        <b-col>
            <datetime v-model="fullTimeString"
                      type="time"
                      input-class="form-control"
                      :state="state"
                      value-zone="local"
                      v-if="isIE">
                <b-button slot="after"
                          :disabled="!fullTimeString"
                          @click="time = null">X
                </b-button>
            </datetime>
            <b-form-input :state="state"
                          v-model="time"
                          type="time"
                          :disabled="disabled"
                          v-if="!isIE"></b-form-input>
        </b-col>
    </b-row>
</template>

<script>
    import {DateTime} from "luxon";

    export default {
        name: 'DateTimeInput',
        props: {
            value: [Date, String],
            disabled: Boolean,
            state: {
                type: Boolean,
                default: null,
            }
        },
        data() {
            return {
                fullDateString: null,
                fullTimeString: null,
                date: null,
                time: null,
            }
        },
        mounted() {
            if (this.value) {
                if (this.value instanceof Date) {
                    let d = DateTime.fromJSDate(this.value);
                    this.fullDateString = d.toISODate();
                    this.fullTimeString = d.toFormat('HH:mm');
                    this.date = d.toISODate();
                    this.time = d.toFormat('HH:mm');
                } else {
                    let d = DateTime.fromISO(this.value);
                    this.fullDateString = d.toISODate();
                    this.fullTimeString = d.toFormat('HH:mm');
                    this.date = d.toISODate();
                    this.time = d.toFormat('HH:mm');
                }
            }
        },
        computed: {
            isIE() {
                let userAgent = window.navigator.userAgent;
                var msie = userAgent.indexOf("MSIE ");

                if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
                {
                    return true;
                } else {
                    return false;
                }
            },
        },
        watch: {
            value(newVal) {
                if (newVal instanceof Date) {
                    let d = DateTime.fromJSDate(newVal);
                    this.fullDateString = d.toISODate();
                    this.fullTimeString = d.toFormat('HH:mm');
                    this.date = d.toISODate();
                    this.time = d.toFormat('HH:mm');
                } else {
                    let d = DateTime.fromISO(newVal);
                    this.fullDateString = d.toISODate();
                    this.fullTimeString = d.toFormat('HH:mm');
                    this.date = d.toISODate();
                    this.time = d.toFormat('HH:mm');
                }
            },
            fullDateString(newVal) {
                if (newVal && newVal.length !== 10) {
                    this.date = DateTime.fromISO(newVal).toISODate();
                } else {
                    this.emitIfValid();
                }
            },
            fullTimeString(newVal) {
                if (newVal && newVal.length !== 10) {
                    this.time = DateTime.fromISO(newVal).toFormat('HH:mm');
                } else {
                    this.emitIfValid();
                }
            },
            date() {
                this.emitIfValid();
            },
            time() {
                this.emitIfValid();
            },
        },
        methods: {
            emitIfValid() {
                let date = DateTime.fromISO(this.date + 'T' + this.time);
                if (!date.invalid) {
                    this.$emit('input', date.toISO());
                } else {
                    this.$emit('input', null);
                }
            },
        },
    }
</script>